import BaseEntity from './BaseEntity';
import Defect from './Defect';
export default class DefectList extends BaseEntity {
    constructor(defectList, totalNodes) {
        super();
        this.defects = [];
        this.totalNodes = totalNodes;
        this.defects = defectList.map(defect => new Defect(defect));
    }
}
